import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';

// Action Types
export const GET_PROVIDER_SUB_CATEGORY = 'GET_PROVIDER_SUB_CATEGORY';
export const GET_PROVIDER_SUB_CATEGORY_SUCCESS =
  'GET_PROVIDER_SUB_CATEGORY_SUCCESS';
export const GET_PROVIDER_SUB_CATEGORY_FAILURE =
  'GET_PROVIDER_SUB_CATEGORY_FAILURE';

// Action Creators
export const fetchGetProviderSubCategory = () => ({
  type: GET_PROVIDER_SUB_CATEGORY,
});

export const fetchGetProviderSubCategorySuccess = (data) => ({
  type: GET_PROVIDER_SUB_CATEGORY_SUCCESS,
  payload: data,
});

export const fetchGetProviderSubCategoryFailure = (error) => ({
  type: GET_PROVIDER_SUB_CATEGORY_FAILURE,
  payload: error,
});

export const getProviderSubCategoryCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetProviderSubCategory(data, external));
    try {
      const response = await getMethodWithToken(
        url.getProviderService + external?.id + '/',
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetProviderSubCategorySuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetProviderSubCategoryFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetProviderSubCategoryFailure(error.message));
    }
  };
};
